export const isTrue = value => value === 'true' || value === true;

export const isYes = value =>
  (value || '').toLowerCase() === 'true' || (value || '').toLowerCase() === 'yes' || value === true;
